export default __webpack_public_path__ + "static/media/csLogo.7b35476a.svg";